import { Box, Divider, Text } from '@factorialco/deprecated-design-system'
import { F0Alert } from '@factorialco/f0-react'
import { Moment } from 'moment'

import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { HeaderCellType } from 'modules/project_management/components/Schedule/Body/ScheduleItem/types'
import { cellText } from 'modules/project_management/components/Schedule/Body/ScheduleItem/utils'

interface Props {
  data: HeaderCellType
}

export const HeaderCellsHoverHeader = ({ data }: Props) => {
  const hoursToPlan = data.expectedMinutes - data.plannedMinutes
  return (
    <Box flexDirection="column" gap="s12">
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text size="200" weight="bold">
          {i18n.t('project_management.planning.header_cells_hover.hours_to_plan')}
        </Text>
        <Text size="200" weight="bold">
          {cellText(hoursToPlan)}
        </Text>
      </Box>
      {hoursToPlan < 0 && (
        <F0Alert
          description={i18n.t('project_management.planning.header_cells_hover.alert_description')}
          title={i18n.t('project_management.planning.header_cells_hover.alert', {
            hours_to_plan: cellText(-hoursToPlan, undefined, 'none'),
          })}
          variant="warning"
        />
      )}
    </Box>
  )
}

export const HeaderCellsHoverContent = ({ data }: Props) => {
  return (
    <Box gap="s4">
      <Box flexDirection="row" justifyContent="spaceBetween" paddingBottom={'s4'}>
        <Text size="100" weight="bold">
          {i18n.t('project_management.planning.header_cells_hover.agreement_hours')}
        </Text>
        <Text size="100" weight="bold">
          {cellText(data.expectedMinutes + data.minutesOff)}
        </Text>
      </Box>
      <Divider />
      <Box flexDirection="row" justifyContent="spaceBetween" paddingY={'s4'}>
        <Text size="100" weight="bold">
          {i18n.t('project_management.planning.header_cells_hover.planned_hours')}
        </Text>
        <Text size="100" weight="bold">
          {cellText(data.plannedMinutes + data.minutesOff)}
        </Text>
      </Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text size="100">{i18n.t('project_management.planning.header_cells_hover.time_off')}</Text>
        <Text size="100">{cellText(data.minutesOff)}</Text>
      </Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text size="100">
          {i18n.t('project_management.planning.header_cells_hover.project_assignation')}
        </Text>
        <Text size="100">{cellText(data.plannedMinutes)}</Text>
      </Box>
    </Box>
  )
}

export const HeaderCellsHoverFooter = ({ data }: Props) => {
  const formatDate = (startDate: Moment, endDate: Moment) => {
    if (startDate.isSame(endDate, 'day')) {
      return i18nDateToString(startDate, 'ui')
    }
    return `${i18nDateToString(startDate, 'ui')} - ${i18nDateToString(endDate, 'ui')}`
  }
  return (
    <Box flexDirection="row" justifyContent="spaceBetween" paddingBottom={'s8'}>
      <Text size="100" weight="bold">
        {i18n.t('project_management.planning.header_cells_hover.date')}
      </Text>
      <Text size="100" weight="bold">
        {formatDate(data.startDate, data.endDate)}
      </Text>
    </Box>
  )
}
